import { ChangeEvent, useEffect, useState } from 'react';
import { faPlugCircleCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SectionHeader } from '@/shared/components/export';
import { messageService } from '@/core/messaging/export';
import { localPreferencesService, MessageConnectionType } from '@/core/preferences/export';
import SettingsSelectField from '@/core/settings/components/settings-select-field';

export default function ConnectionTab() {
  const [connectionType, setConnectionType] = useState(messageService.getConnectionType());

  useEffect(() => {
    localPreferencesService.getLocalPreferences().then(value => {
      if (value.messageConnectionType) setConnectionType(value.messageConnectionType);
    });
  }, []);

  const onSelectConnectionType = async (event: ChangeEvent<HTMLSelectElement>) => {
    const value = event.target.value as MessageConnectionType;
    if (value === connectionType) return;

    const preferences = await localPreferencesService.updateLocalPreferences(
      async localPreferences => {
        localPreferences.messageConnectionType = value;

        return localPreferences;
      },
    );

    setConnectionType(preferences.messageConnectionType);
    messageService.setConnectionType(preferences.messageConnectionType);
    await messageService.reactivateConnection();
  };

  return (
    <div style={{ flex: '1 1 auto', paddingRight: 24 }}>
      <SectionHeader title="Real-Time Connection Technology" />

      <SettingsSelectField
        label="Transport"
        value={connectionType}
        onChange={onSelectConnectionType}
        helpText={
          <ul className="mb-0 ps-3">
            <li>
              <FontAwesomeIcon className="text-success me-1" icon={faPlugCircleCheck} />
              Websockets: this provides the lowest latency possible, but may not work with some
              firewalls and network hardware.
            </li>
            <li>
              <FontAwesomeIcon className="text-info me-1" icon={faPlugCircleCheck} />
              HTTP Streaming: this provides good latency, and low-bandwidth usage.
            </li>
            <li>
              <FontAwesomeIcon className="text-secondary me-1" icon={faPlugCircleCheck} />
              HTTP Polling: this works with older browsers.
            </li>
          </ul>
        }
      >
        <option value={MessageConnectionType.WEBSOCKET}>Websockets (Best)</option>
        <option value={MessageConnectionType.STREAMING}>HTTP Streaming (Better)</option>
        <option value={MessageConnectionType.POLLING}>HTTP Polling (Good)</option>
      </SettingsSelectField>
    </div>
  );
}
